import React, { Fragment, useEffect, useState, useContext } from "react";
import { Link, withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { MenuMain } from "./MenuMain";
import { Playlist } from "./Playlist";
import { Player } from "./Player";
import { Project } from "./Project";

export function Projects({ videoId }) {
  const context = useContext(Context);
  return (
    <>
      <div className="l_projects">
        {context.data["projects"].map((one) => (

            <div
              // className="l_playlist l_playlist--sm"
              // className="l_playlist"
              key={`project_playlist_${one["id"]}`}
            >
              <Project {...one} />
            </div>

        ))}
      </div>
    </>
  );
}
